import { LS_get, LS_remove, LS_set } from './LS'

export function LS_accessTokenGet(): string {
    return LS_get('accessToken')
}

export function LS_accessTokenSet(accessToken: string) {
    LS_set('accessToken', accessToken)
}

export function LS_accessTokenRemove() {
    LS_remove('accessToken')
}
